var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SnowflakeAuth_1;
import { BeforeDeserialized, JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './userPassword'; // force import for JsonSchemaV2
import { UserPassword } from './userPassword';
import { ConnectionType } from './connection';
import { ConnectionAuth } from './connectionAuth';
import './snowflakeStorageIntegration';
import { snowflakeAuthSchemaValidation } from '../validations.generated';
export var SnowflakeCredentialsType;
(function (SnowflakeCredentialsType) {
    SnowflakeCredentialsType["Basic"] = "basic";
    SnowflakeCredentialsType["OAuth"] = "oauth";
})(SnowflakeCredentialsType || (SnowflakeCredentialsType = {}));
export const snowflakeAuthSchema = {
    $id: 'urn:wisepipe-common-connection:SnowflakeAuth',
    type: 'object',
    properties: {
        account: { type: 'string' },
        warehouse: { type: 'string' },
        dbname: { type: 'string' },
        authMethod: { type: 'string', enum: Object.values(SnowflakeCredentialsType) },
        userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' },
        role: { type: 'string' },
        code: { type: 'string' },
        clientID: { type: 'string' },
        clientSecret: { type: 'string' },
        redirectUri: { type: 'string' },
        storageIntegration: { $ref: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration' },
        externalID: { type: 'string' }
    },
    required: ['account', 'warehouse', 'dbname'],
    if: { properties: { authMethod: { const: SnowflakeCredentialsType.Basic } } },
    then: { required: ['userPassword'] },
    else: { required: ['clientID', 'clientSecret', 'redirectUri', 'code'] }
};
let SnowflakeAuth = SnowflakeAuth_1 = class SnowflakeAuth extends ConnectionAuth {
    setDefaults() {
        this.authMethod = SnowflakeCredentialsType.Basic;
    }
    constructor(nonce, account, warehouse, dbname, authMethod, user, password, role, code, clientID, clientSecret, redirectUri, storageIntegration, externalID) {
        super(ConnectionType.Snowflake, nonce);
        this.account = account;
        this.warehouse = warehouse;
        this.dbname = dbname;
        this.authMethod = authMethod;
        if (this.authMethod === SnowflakeCredentialsType.Basic) {
            if (!(user && password)) {
                throw new Error('Basic auth requires user and password');
            }
            this.userPassword = new UserPassword(user, password);
        }
        else {
            if (!(code && clientID && clientSecret && redirectUri)) {
                throw new Error('OAuth auth requires code, clientID, clientSecret, and redirectUri');
            }
            this.code = code;
            this.clientID = clientID;
            this.clientSecret = clientSecret;
            this.redirectUri = redirectUri;
        }
        this.role = role;
        this.storageIntegration = storageIntegration;
        this.externalID = externalID;
        JSON.validate(this, SnowflakeAuth_1);
    }
};
__decorate([
    BeforeDeserialized()
], SnowflakeAuth.prototype, "setDefaults", null);
SnowflakeAuth = SnowflakeAuth_1 = __decorate([
    JsonSchemaV2(snowflakeAuthSchema, snowflakeAuthSchemaValidation),
    JsonDiscriminatorValue(ConnectionType.Snowflake)
], SnowflakeAuth);
export { SnowflakeAuth };
//# sourceMappingURL=snowflakeAuth.js.map